// import React from 'react';
// import { useCart } from '../../context/CartContext';
// import { useAuth } from '../../auth/AuthContext';
// import { useLoginModal } from '../../context/LoginModalWrapper';
// import { useAddressManagement } from './hooks/useAddressManagement';
// import { useCheckout } from './hooks/useCheckout';
// import EmptyCart from './EmptyCart';
// import CartItem from './CartItem';
// import AddressDropdown from './AddressDropdown';
// import OrderSummary from './OrderSummary';
// import AddressForm from './AddressForm';
// import { 
//   FaMapMarkerAlt, 
//   FaChevronDown, 
//   FaChevronUp,
//   FaShoppingCart,
//   FaUserAlt
// } from 'react-icons/fa';
// const CartDrawer = ({ open, onClose }) => {
//   const { cartItems, removeFromCart, updateQuantity, clearCart } = useCart();
//   const { user } = useAuth();
//   const { openLoginModal } = useLoginModal();

//   const {
//     userAddresses,
//     selectedAddress,
//     showAddressDropdown,
//     showAddressForm,
//     form,
//     setSelectedAddress,
//     setShowAddressDropdown,
//     setShowAddressForm,
//     handleAddressChange,
//     handleAddressSubmit,
//     isProcessing: isAddressProcessing
//   } = useAddressManagement(user);
//   const subtotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
//   const {
//     handleCheckout,
//     isProcessing: isCheckoutProcessing
//   } = useCheckout({
//     user,
//     selectedAddress,
//     subtotal,
//     clearCart,
//     onClose,
//     openLoginModal
//   });


//   return (
//     <div className={`fixed top-0 ${open ? 'right-0' : '-right-full'} 
//       h-full z-50 bg-white transition-all duration-300 
//       w-full md:w-[450px] shadow-xl border-l flex flex-col`}>
      
//       {/* Header */}
//       <div className="p-4 flex justify-between items-center border-b">
//         <h2 className="text-xl font-bold text-gray-800">Your Shopping Cart</h2>
//         <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">
//           &times;
//         </button>
//       </div>

//       {/* Cart items */}
//       <div className="flex-1 overflow-auto p-4">
//         {cartItems.length === 0 ? (
//           <EmptyCart onClose={onClose} />
//         ) : (
//           <div className="space-y-4">
//             {cartItems.map((item) => (
//               <CartItem 
//                 key={item.id} 
//                 item={item} 
//                 updateQuantity={updateQuantity} 
//                 removeFromCart={removeFromCart} 
//               />
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Address and Checkout Section */}
//       {cartItems.length > 0 && (
//         <div className="border-t">
//           <div className="p-4 border-b">
//             <div 
//               className="cursor-pointer flex justify-between items-center"
//               onClick={() => setShowAddressDropdown(!showAddressDropdown)}
//             >
//               <div className="flex items-center space-x-2">
//                 <FaMapMarkerAlt className="text-nlue-600" />
//                 <span className="font-medium text-gray-700">
//                   {selectedAddress ? 'Delivery Address' : 'Select Delivery Address'}
//                 </span>
//               </div>
//               {showAddressDropdown ? (
//                 <FaChevronUp className="text-gray-500" />
//               ) : (
//                 <FaChevronDown className="text-gray-500" />
//               )}
//             </div>

//             {showAddressDropdown && (
//               <AddressDropdown 
//                 userAddresses={userAddresses}
//                 selectedAddress={selectedAddress}
//                 setSelectedAddress={setSelectedAddress}
//                 setShowAddressDropdown={setShowAddressDropdown}
//                 setShowAddressForm={setShowAddressForm}
//               />
//             )}

//             {selectedAddress && !showAddressDropdown && (
//               <div className="mt-3 p-3 bg-gray-50 rounded-lg">
//                 <div className="flex justify-between">
//                   <span className="font-medium">{selectedAddress.name}</span>
//                   {selectedAddress.isDefault && (
//                     <span className="text-xs bg-nlue-100 text-nlue-800 px-2 py-1 rounded-full">
//                       Default
//                     </span>
//                   )}
//                 </div>
//                 <p className="text-sm text-gray-600 mt-1">{selectedAddress.addressLine1}</p>
//                 {/* {selectedAddress.addressLine2 && (
//                   <p className="text-sm text-gray-600">{selectedAddress.addressLine2}</p>
//                 )}
//                 <p className="text-sm text-gray-600">
//                   {selectedAddress.city}, {selectedAddress.state} - {selectedAddress.pincode}
//                 </p> */}
//                 <p className="text-sm text-gray-600">Phone: {selectedAddress.phone}</p>
//               </div>
//             )}
//           </div>

//           <OrderSummary 
//             subtotal={subtotal}
//             selectedAddress={selectedAddress}
//             handleCheckout={handleCheckout}
//             isProcessing={isCheckoutProcessing || isAddressProcessing}
//           />
//         </div>
//       )}

//       {showAddressForm && (
//         <AddressForm 
//           form={form}
//           handleAddressChange={handleAddressChange}
//           handleAddressSubmit={handleAddressSubmit}
//           isProcessing={isAddressProcessing}
//           setShowAddressForm={setShowAddressForm}
//         />
//       )}
//     </div>
//   );
// };

// export default CartDrawer;
import { useEffect } from 'react';
import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../auth/AuthContext';
import { useLoginModal } from '../../context/LoginModalWrapper';
import { useAddressManagement } from './hooks/useAddressManagement';
import EmptyCart from './EmptyCart';
import CartItem from './CartItem';
import AddressDropdown from './AddressDropdown';
import OrderSummary from './OrderSummary';
import AddressForm from './AddressForm';
import OfferPopup from './OfferPopup';
import { FaMapMarkerAlt, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { usePopup } from '../../context/PopupContext';

const CartDrawer = ({ open, onClose }) => {
  const { cartItems, removeFromCart, updateQuantity, clearCart } = useCart();
  const { user } = useAuth();
  const { openLoginModal } = useLoginModal();
  const [showOfferPopup, setShowOfferPopup] = useState(false);
  const { showPopup } = usePopup();

  const {
    userAddresses,
    selectedAddress,
    showAddressDropdown,
    showAddressForm,
    form,
    setSelectedAddress,
    setShowAddressDropdown,
    setShowAddressForm,
    handleAddressChange,
    handleAddressSubmit,
    isProcessing: isAddressProcessing,
  } = useAddressManagement(user);

  const subtotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
useEffect(() => {
  if (open && cartItems.length && window.gtag) {
    const totalValue = cartItems.reduce(
      (sum, item) => sum + item.price * item.quantity,
      0
    );

    window.gtag('event', 'view_cart', {
      currency: 'INR',
      value: totalValue,
      items: cartItems.map(item => ({
        item_id: item.id,
        item_name: item.name,
        quantity: item.quantity,
        price: item.price,
      })),
    });
  }
}, [open, cartItems]);

  const handleProceedToCheckout = () => {
    if (!user) {
      openLoginModal();
      onClose();
      return;
    }

    if (!selectedAddress) {
      // alert('Please select an address before checkout.');
      showPopup('Please select an address before checkout.');

      return;
    }

    setShowOfferPopup(true);
  };

  return (
    <>
      <div
        className={`fixed top-0 ${open ? 'right-0' : '-right-full'} h-full z-50 bg-white transition-all duration-300 w-full md:w-[450px] shadow-xl border-l flex flex-col`}
      >
        {/* Header */}
        <div className="p-4 flex justify-between items-center border-b">
          <h2 className="text-xl font-bold text-gray-800">Your Shopping Cart</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl">
            &times;
          </button>
        </div>

        {/* Cart Items */}
        <div className="flex-1 overflow-auto p-4">
          {cartItems.length === 0 ? (
            <EmptyCart onClose={onClose} />
          ) : (
            <div className="space-y-4">
              {cartItems.map((item) => (
                <CartItem
                  key={item.id}
                  item={item}
                  updateQuantity={updateQuantity}
                  removeFromCart={removeFromCart}
                />
              ))}
            </div>
          )}
        </div>

        {/* Address and Checkout Section */}
        {cartItems.length > 0 && (
          <div className="border-t">
            <div className="p-4 border-b">
              <div
                className="cursor-pointer flex justify-between items-center"
                onClick={() => setShowAddressDropdown(!showAddressDropdown)}
              >
                <div className="flex items-center space-x-2">
                  <FaMapMarkerAlt className="text-nlue-600" />
                  <span className="font-medium text-gray-700">
                    {selectedAddress ? 'Delivery Address' : 'Select Delivery Address'}
                  </span>
                </div>
                {showAddressDropdown ? (
                  <FaChevronUp className="text-gray-500" />
                ) : (
                  <FaChevronDown className="text-gray-500" />
                )}
              </div>

              {showAddressDropdown && (
                <AddressDropdown
                  userAddresses={userAddresses}
                  selectedAddress={selectedAddress}
                  setSelectedAddress={setSelectedAddress}
                  setShowAddressDropdown={setShowAddressDropdown}
                  setShowAddressForm={setShowAddressForm}
                />
              )}

              {selectedAddress && !showAddressDropdown && (
                <div className="mt-3 p-3 bg-gray-50 rounded-lg">
                  <div className="flex justify-between">
                    <span className="font-medium">{selectedAddress.name}</span>
                    {selectedAddress.isDefault && (
                      <span className="text-xs bg-nlue-100 text-nlue-800 px-2 py-1 rounded-full">
                        Default
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-gray-600 mt-1">{selectedAddress.addressLine1}</p>
                  <p className="text-sm text-gray-600">Phone: {selectedAddress.phone}</p>
                </div>
              )}
            </div>

            <OrderSummary
              subtotal={subtotal}
              selectedAddress={selectedAddress}
              openOfferPopup={handleProceedToCheckout}
              isProcessing={isAddressProcessing}
              
            />
          </div>
        )}

        {/* Address Form */}
        {showAddressForm && (
          <AddressForm
            form={form}
            handleAddressChange={handleAddressChange}
            handleAddressSubmit={handleAddressSubmit}
            isProcessing={isAddressProcessing}
            setShowAddressForm={setShowAddressForm}
          />
        )}
      </div>

      {/* Offer Popup */}
      {showOfferPopup && (
        <OfferPopup
          subtotal={subtotal}
          cartItems={cartItems}
          onClose={() => setShowOfferPopup(false)}
          selectedAddress={selectedAddress}
          closeCartDrawer={onClose}
        />
      )}
    </>
  );
};

export default CartDrawer;
